/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import TimeSeriesValueCard from '@/components/kpi/TimeSeriesValueCard';
import TimeSeriesValueCarousel from '@/components/kpi/TimeSeriesValueCarousel';
import type { TimeSeriesTrafficLightConfig } from '@/lib/timeSeries/timeSeriesValue';

interface KpiCarouselStaticModalConfig {
    buttonLabel?: string;
    message: string;
    title?: string;
}

export interface KpiCarouselStaticItem {
    conversion?: number;
    date?: string | null;
    fractionDigits?: number;
    key: string;
    offset?: number;
    title?: string;
    trafficLight?: TimeSeriesTrafficLightConfig;
    unit?: string | null;
    value: number | null;
}

interface KpiCarouselStaticProps {
    autoAdvanceMs?: number;
    info?: string;
    items: KpiCarouselStaticItem[];
    link?: string;
    modal?: KpiCarouselStaticModalConfig;
    showLegend?: boolean;
}

function KpiCarouselStatic({
    autoAdvanceMs,
    info,
    items,
    link,
    modal,
    showLegend = false,
}: KpiCarouselStaticProps) {
    return (
        <TimeSeriesValueCarousel
            autoAdvanceMs={autoAdvanceMs}
            items={items.map((item) => ({
                key: item.key,
                content: (
                    <TimeSeriesValueCard
                        conversion={item.conversion}
                        fractionDigits={item.fractionDigits}
                        info={info}
                        link={link}
                        metaDate={item.date}
                        modal={modal}
                        offset={item.offset}
                        showLegend={showLegend}
                        title={item.title}
                        trafficLight={item.trafficLight}
                        unit={item.unit}
                        value={item.value}
                    />
                ),
            }))}
        />
    );
}

export default KpiCarouselStatic;
